export const AppRoute = {
  AmmatillinenKoulutus: "routes.ammatillinenKoulutus",
  Asia: "routes.asia",
  Asianhallinta: "routes.asianhallinta",
  AsianhallintaAvoimet: "routes.asianhallintaAvoimet",
  AsianhallintaKorjattavat: "routes.asianhallintaKorjattavat",
  AsianhallintaPaatetyt: "routes.asianhallintaPaatetyt",
  CasAuth: "routes.casAuth",
  CasLogOut: "routes.casLogOut",
  CasReady: "routes.casReady",
  UusiAsiaEsivalinnat: "routes.uusiAsiaEsivalinnat",
  EsiJaPerusopetus: "routes.esiJaPerusopetus",
  Hakemus: "routes.hakemus",
  Home: "routes.home",
  Jarjestaja: "routes.jarjestaja",
  JarjestamisJaYllapitamisluvat: "routes.jarjestamisJaYllapitamisluvat",
  Jarjestamislupa: "routes.jarjestamislupa",
  // Oiva-daily August 6, 2026: This route (Jarjestamislupaasiat) is most likely dead code left over from
  // removing a feature where education organizers could manage their permits.
  // Only referenced from wizardUtils.ts (role === "KJ") and Jarjestaja/index.jsx
  // (tab shown when the logged-in user is the jarjestaja themselves), and no
  // <Route> is registered for it in Asianhallinta/index.jsx.
  Jarjestamislupaasiat: "routes.jarjestamislupaasiat",
  KaikkiJarjestajat: "routes.kaikkiJarjestajat",
  Koulutustoimijat: "routes.koulutustoimijat",
  KoulutusmuodonEtusivu: "routes.koulutusmuodonEtusivu",
  LogIn: "routes.logIn",
  LogOut: "routes.logOut",
  Lukiokoulutus: "routes.lukiokoulutus",
  Paatokset: "routes.paatokset",
  Saavutettavuusseloste: "routes.saavutettavuusseloste",
  Sivukartta: "routes.sivukartta",
  TaiteenPerusopetus: "routes.taiteenPerusopetus",
  Tilastot: "routes.tilastot",
  Tuva: "routes.tuva",
  Tuvahakemus: "routes.tuvahakemus",
  UusiHakemus: "routes.uusiHakemus",
  UusiHakemusVST: "routes.uusiHakemusVST",
  UusiHakemusTUVA: "routes.uusiHakemusTUVA",
  VapaaSivistystyo: "routes.vapaaSivistystyo",
  Yhteydenotto: "routes.yhteydenotto"
};
